'use client';

import Image from 'next/image';
import { cn } from '~/lib/utils';

export function ConnectIconTile({
  src,
  alt,
  size = 'md',
  className,
}: {
  src: string;
  alt: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}) {
  const box =
    size === 'lg'
      ? 'size-12 rounded-xl'
      : size === 'sm'
        ? 'size-8 rounded-[10px]'
        : 'size-9 rounded-[10px]';
  const px = size === 'lg' ? 24 : size === 'sm' ? 16 : 18;

  return (
    <span
      className={cn(
        'bg-muted ring-border/60 flex shrink-0 items-center justify-center ring-1',
        box,
        className,
      )}
    >
      <Image
        src={src}
        alt={alt}
        width={px}
        height={px}
        className="object-contain"
        style={{ width: px, height: px }}
      />
    </span>
  );
}
